import { DefaultNamingConventions, emptySchema, SchemaValidator } from '@contember/schema-utils';
import { produce } from 'immer';
import { emptySchemaExtensions } from '../common';
import { SchemaBuilder } from './builder/SchemaBuilder';
import { SchemaPartsFactory } from './builder/SchemaPartsFactory';
export class SchemaDslBuilderError extends Error {
}
export class SchemaDslBuilder {
    constructor(schema = emptySchema, schemaExtensions = emptySchemaExtensions, statementHandlers = {}, silentErrors = true) {
        Object.defineProperty(this, "schemaExtensions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: schemaExtensions
        });
        Object.defineProperty(this, "statementHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: statementHandlers
        });
        Object.defineProperty(this, "silentErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: silentErrors
        });
        Object.defineProperty(this, "builder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.builder = new SchemaBuilder(schema, new SchemaPartsFactory(new DefaultNamingConventions()), new DefaultNamingConventions(), {});
    }
    get schema() {
        return this.builder.schema;
    }
    get extensions() {
        return this.schemaExtensions;
    }
    updateSchema(cb) {
        this.builder = cb(this.builder);
    }
    updateSchemaExtensions(cb) {
        this.schemaExtensions = produce(this.schemaExtensions, it => {
            cb(it);
        });
    }
    applyStatements(statements) {
        const errors = [];
        const humanReadableStatements = [];
        for (const stmt of statements) {
            const prevBuilder = this.builder;
            let localErrors = [];
            try {
                this.handleStatement(stmt);
            }
            catch (e) {
                if (!this.silentErrors) {
                    console.warn(e);
                }
                const { message } = e;
                localErrors = [message];
            }
            if (localErrors.length === 0) {
                try {
                    localErrors = SchemaValidator.validate(this.builder.schema).map(it => it.message);
                }
                catch (e) {
                    const { message } = e;
                    localErrors = [message];
                }
            }
            if (localErrors.length) {
                this.builder = prevBuilder;
            }
            errors.push(...localErrors.map(it => ({
                ...stmt,
                error: it,
            })));
            humanReadableStatements.push(this.statementHandlers[stmt.type].getHumanStmt(stmt));
        }
        return {
            schema: { contemberSchema: this.builder.schema, schemaExtensions: this.schemaExtensions },
            errors: errors,
            humanReadableStatements: humanReadableStatements,
        };
    }
    handleStatement(stmt) {
        if (stmt.type in this.statementHandlers) {
            this.statementHandlers[stmt.type].apply(stmt, this);
        }
        else {
            throw new SchemaDslBuilderError(`Unknown statement type ${stmt.type}`);
        }
    }
}
//# sourceMappingURL=SchemaDslBuilder.js.map